import React from "react";
import ForgotPasswordForm from "../components/Login-Registration/ForgotPasswordForm";
import HeadComponent from "../components/global/HeadComponent";
import { Link } from "react-router-dom";
const ForgotPassword = () => {
  return (
    <div className="flex  justify-center pt-40 h-screen  gap-x-3">
      <div className="w-1/2">
        <HeadComponent />
        <h3 className="text-3xl mb-8">Forgot password?</h3>
        <ForgotPasswordForm />
      </div>
      <div className="w-1/2 flex flex-col relative">
        <div className="absolute right-0 top-0">
          {" "}
          <Link
            to="/"
            className=" bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow cursor-pointer"
          >
            Back
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
